import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorSpeedAction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M13.271 1.3a.75.75 0 0 1 .473.792L12.85 9.25h6.65a.75.75 0 0 1 .612 1.184l-8.5 12a.75.75 0 0 1-1.356-.527l.894-7.156H4.5a.75.75 0 0 1-.612-1.184l8.5-12a.75.75 0 0 1 .883-.266Zm-7.32 11.95H12a.75.75 0 0 1 .744.842l-.63 5.036 5.936-8.379H12a.75.75 0 0 1-.744-.843l.63-5.035-5.936 8.378Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M3.055 3.055A2.75 2.75 0 0 1 5 2.25h2a.75.75 0 0 1 0 1.5H5A1.25 1.25 0 0 0 3.75 5v2a.75.75 0 1 1-1.5 0V5c0-.73.29-1.43.805-1.945ZM16.25 3a.75.75 0 0 1 .75-.75h2A2.75 2.75 0 0 1 21.75 5v2a.75.75 0 0 1-1.5 0V5A1.25 1.25 0 0 0 19 3.75h-2a.75.75 0 0 1-.75-.75ZM3 16.25a.75.75 0 0 1 .75.75v2A1.25 1.25 0 0 0 5 20.25h2a.75.75 0 0 1 0 1.5H5A2.75 2.75 0 0 1 2.25 19v-2a.75.75 0 0 1 .75-.75Zm18 0a.75.75 0 0 1 .75.75v2A2.75 2.75 0 0 1 19 21.75h-2a.75.75 0 0 1 0-1.5h2A1.25 1.25 0 0 0 20.25 19v-2a.75.75 0 0 1 .75-.75Z"
    />
  </svg>
);
export default SvgTwoColorSpeedAction;
